import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <main className="bg-background-50">
        <div className="mx-auto flex w-full max-w-2xl flex-col items-center px-4 py-24 text-center md:px-6 md:py-32">
          <span className="font-heading text-7xl font-bold text-primary-500 md:text-8xl">
            404
          </span>
          <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t("notFound.title")}
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            {t("notFound.body")}
          </p>
          <Link
            to="/"
            className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            {t("nav.home")}
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-left-line"></i>
            </span>
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}